import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'
import Recruit, {IRecruit} from '@/models/Recruit'
import User, {IUser} from '@/models/User'
import * as dayjs from 'dayjs'

export interface IApplicant extends IModelBase {
  user_id: number
  recruit_id: number
  user?: IUser
  recruit?: IRecruit
  result?: string
  applied_on?: string
  recommended_on?: string
  interviewed_on?: string
  offered_on?: string
  accepted_on?: string
  recommended?: boolean
  interviewed?: boolean
  offered?: boolean
  accepted?: boolean
  created_by: string
  memo?: string
  years?: number
  closed?: boolean
}

export default class Applicant extends ModelBase {
  user_id: number
  recruit_id: number
  user?: User
  recruit?: Recruit
  result: string
  applied_on?: string
  recommended_on?: string
  interviewed_on?: string
  offered_on?: string
  accepted_on?: string
  recommended?: boolean
  interviewed?: boolean
  offered?: boolean
  accepted?: boolean
  created_by: string
  memo?: string
  years?: number = dayjs().year()
  closed = false

  constructor(defaults?: IApplicant) {
    super(defaults)
    if (defaults) {
      this.user_id = defaults.user_id
      this.recruit_id = defaults.recruit_id
      this.user = defaults.user ? new User(defaults.user) : undefined
      this.recruit = defaults.recruit ? new Recruit(defaults.recruit) : undefined
      this.result = defaults.result
      this.applied_on = defaults.applied_on ? dayjs(defaults.applied_on).format('YYYY-MM-DD') : undefined
      this.recommended_on = defaults.recommended_on ? dayjs(defaults.recommended_on).format('YYYY-MM-DD') : undefined
      this.interviewed_on = defaults.interviewed_on ? dayjs(defaults.interviewed_on).format('YYYY-MM-DD') : undefined
      this.offered_on = defaults.offered_on ? dayjs(defaults.offered_on).format('YYYY-MM-DD') : undefined
      this.accepted_on = defaults.accepted_on ? dayjs(defaults.accepted_on).format('YYYY-MM-DD') : undefined
      this.recommended = defaults.recommended
      this.interviewed = defaults.interviewed
      this.offered = defaults.offered
      this.accepted = defaults.accepted
      this.created_by = defaults.created_by
      this.memo = defaults.memo
      this.years = defaults.years
      this.closed = defaults.closed || false
    }
  }

  get appliedOnString(): string {
    return this.applied_on ? dayjs(this.applied_on).format('YYYY/MM/DD') : null
  }

  get recommendedOnString(): string {
    return this.recommended_on ? dayjs(this.recommended_on).format('YYYY/MM/DD') : null
  }

  get interviewedOnString(): string {
    return this.interviewed_on ? dayjs(this.interviewed_on).format('YYYY/MM/DD') : null
  }

  get offeredOnString(): string {
    return this.offered_on ? dayjs(this.offered_on).format('YYYY/MM/DD') : null
  }

  get acceptedOnString(): string {
    return this.accepted_on ? dayjs(this.accepted_on).format('YYYY/MM/DD') : null
  }

  toParams(): KeyPair {
    return {
      result: this.result,
      memo: this.memo,
      years: this.years,
      closed: this.closed,
      user_id: this.user_id,
      recruit_id: this.recruit_id,
      applied_on: this.applied_on,
      recommended_on: this.recommended_on,
      interviewed_on: this.interviewed_on,
      offered_on: this.offered_on,
      accepted_on: this.accepted_on,
      recommended: this.recommended,
      interviewed: this.interviewed,
      offered: this.offered,
      accepted: this.accepted,
      created_by: this.created_by
    }
  }
}
